import ResultsIntro from './ResultsIntro'

export default ResultsIntro